import {
  IncidentProduct,
  IncidentSeverity,
} from "@redotech/redo-model/incidents/incident";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

const currentIncidentSchema = z.object({
  _id: zExt.objectId(),
  message: z.string(),
  severity: createEnum(IncidentSeverity),
  type: createEnum(IncidentProduct),
  publicUrl: z.string().nullish(),
  adminOnly: z.boolean().optional(),
  routeScoped: z.boolean().optional(),
});

export type CurrentIncident = z.infer<typeof currentIncidentSchema>;

export const getCurrentIncidents = {
  name: "getCurrentIncidents" as const,
  input: z.null(),
  output: zExt.filterToValidArray(currentIncidentSchema),
};
